var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeedbackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.25 3.31888V14.4916C0.25 15.8409 1.35137 16.9355 2.71112 16.9355H13.7987L17.695 21.125V16.9351H20.2892C21.6482 16.9351 22.7504 15.8405 22.7504 14.4913V3.31888C22.75 1.96925 21.6482 0.875 20.2892 0.875H2.71112C1.35137 0.875 0.25 1.96925 0.25 3.31888ZM15.9227 8.90487C15.9227 8.0375 16.6307 7.334 17.5049 7.334C18.379 7.334 19.087 8.0375 19.087 8.90487C19.087 9.773 18.379 10.4761 17.5049 10.4761C16.6307 10.4761 15.9227 9.77337 15.9227 8.90487ZM9.91787 8.90487C9.91787 8.0375 10.6266 7.334 11.5 7.334C12.3734 7.334 13.0821 8.0375 13.0821 8.90487C13.0821 9.773 12.3734 10.4761 11.5 10.4761C10.6266 10.4761 9.91787 9.77337 9.91787 8.90487ZM3.91337 8.90487C3.91337 8.0375 4.62212 7.334 5.4955 7.334C6.36962 7.334 7.07762 8.0375 7.07762 8.90487C7.07762 9.773 6.36962 10.4761 5.4955 10.4761C4.62175 10.4765 3.91337 9.77337 3.91337 8.90487Z",
    fill: "#111111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedbackIcon);
export default __webpack_public_path__ + "static/media/feedback_icon.d7ed053d4cf6e2a486bb1c103c4af9fe.svg";
export { ForwardRef as ReactComponent };